<template>
  <div class="mindex">
    <div class="header">
      <img src="../assets/logo.jpg" alt="">
      <!-- <h3>闻源漫画-快看引流平台</h3> -->
       <!-- <h3>闻源漫画-腾讯引流平台</h3> -->
       <!-- <h3>闻源漫画-微博引流平台</h3> -->
       <!-- <h3>闻源漫画-漫画人引流平台</h3> -->
      <!-- <h3>闻源漫画-漫漫引流平台</h3> -->
      <h3>闻源漫画-奇热引流平台</h3>

    </div>
    <div class="container">
      <div class="item" v-for="(item,index) in list" :key="'mh'+index" @click="toDetail(item.id)">
        <div class="img">
          <img :src="item.url" alt="">
          <div class="cover"></div>
        </div>
        <div class="detail">
          <h3 class="title">{{item.name}}</h3>
          <p class="author">{{item.author}}</p>
          <div class="instr">
            <!-- <span>漫画简介</span> -->
            {{item.instr}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../util/rem'
import _isMobile from '../util/util'
// import list from '../util/list';//快看
// import list from '../util/txlist';//腾讯
// import list from '../util/wblist';//微博
// import list from '../util/mmlist';//漫漫
import list from '../util/qrlist';//奇热
// import list from '../util/yqlist';//瑛麒

export default {
  data() {
    return {
      list: list
    }
  },
  mounted() {
    if (_isMobile()) {
      // alert("手机端");
      this.$router.replace('/m');
    } else {
      // alert("pc端");
      this.$router.replace('/');
    }
    console.log(list);
  },
  methods: {

    toDetail(id) {
      this.$router.push({ path: `\detail?id=${id}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.mindex {
  background-color: #f8f8f8;
  font-size: 1rem;
  padding-bottom: 3.125rem;

  .header {
    height: 3rem;
    // background-color: #ff9a6a;
    background-color: #fff;
    // background-color: #000;
    // color: #fff;
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    align-items: center;

    img {
      border-radius: .325rem;
      position: absolute;
      left: 1rem;
      top: .325rem;
      width: 2.5rem;
      height: 2.5rem;
    }

    h3 {
      width: 100%;
      text-align: center;
    }
  }

  .container {
    padding: 3rem 1rem;

    .item {
      padding: .625rem;
      margin-top: .9375rem;
      background-color: #fff;
      display: flex;
      justify-content: flex-start;

      .img {
        width: 5.75rem;

        img {
          display: block;
          width: 5.75rem;
          border-radius: .3rem;
        }
      }

      .detail {
        text-align: left;
        font-size: .75rem;
        margin-left: .9375rem;
        color: #999;

        h3 {
          color: #000;
          margin-top: .3125rem;
          font-size: .875rem;
        }

        .author {
          margin-top: .3125rem;
          font-size: .75rem;
        }

        .instr {
          margin-top: .625rem;
          width: 12.5rem;
          height: 3.8rem;
          line-height: 20px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
        }
      }
    }
  }
}
</style>